const SHOW_THRESHOLD = 900
const FOOTER_GAP = 16

export function initBackToTop(): void {
    const button = document.getElementById('js-back-to-top')
    if (!button) return

    window.addEventListener('scroll', () => {
        button.classList.toggle('is-visible', window.scrollY > SHOW_THRESHOLD)
    }, { passive: true })

    button.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    })

    // フッターに重ならないよう、フッターが見えたら absolute 配置に切り替える
    const footer = document.querySelector<HTMLElement>('.footer')
    if (!footer) return

    const updatePosition = (): void => {
        button.style.bottom = `${footer.offsetHeight + FOOTER_GAP}px`
    }

    const observer = new IntersectionObserver((entries) => {
        const isAboveFooter = entries[0].isIntersecting
        button.classList.toggle('is-above-footer', isAboveFooter)
        if (isAboveFooter) {
            updatePosition()
        } else {
            button.style.bottom = ''
        }
    })
    observer.observe(footer)

    window.addEventListener('resize', () => {
        if (button.classList.contains('is-above-footer')) updatePosition()
    }, { passive: true })
}
